import { Document, Page, Text, View, StyleSheet, Image, Font } from "@react-pdf/renderer";

Font.register({
    family: 'Poppins',
    fonts: [
        {
            src: '/fonts/Poppins-Regular.ttf',
            fontWeight: 'normal',
        },
        {
            src: '/fonts/Poppins-SemiBold.ttf',
            fontWeight: 600,
        },
        {
            src: '/fonts/Poppins-Bold.ttf',
            fontWeight: 'bold',
        },
    ],
});

// Create styles
const styles = StyleSheet.create({
    page: {
        padding: 30,
    },
    col: {
        display: "flex",
        flexDirection: "row",
        //border: "1px solid black",
    }
});


const YearlyReport = ({ data }) => {

    

    const newdata = data.data

    const startYear = new Date(data.startdate).getFullYear() || '2016';
    const endYear = new Date(data.enddate).getFullYear() || new Date().getFullYear();;


    const totalcount = newdata.reduce((acc, item) => {
        const total = acc + item.Student_Count
        return total
    }, 0)

    return (
        <Document>
            <Page size="A4" style={{ padding: 30, paddingRight: 100, paddingLeft: 60, fontSize: 10, }}>
                <View style={[styles.header, { fontSize: "10px" }]}>
                    <Text style={{ fontFamily: "Poppins", fontWeight: "bold" }}>Suvidya Institute of Technology Pvt. Ltd.</Text>
                </View>

                <View style={[styles.row, { marginBottom: "2%", border: "1px solid black", fontSize: "10px", textAlign: "center", }]}>
                    <Text style={{ fontFamily: "Poppins", fontWeight: "bold" }}>Admission Between  {startYear} - {endYear}</Text>
                </View>

                <View style={[styles.col, { border: "1px solid black", fontSize: "10px", textAlign: "center", width: "100%" }]}>
                    <View style={{ borderRight: "1px solid black", width: "10%" }}>
                        <Text style={{ textAlign: "center", fontSize: 10, fontFamily: "Poppins", fontWeight: "bold" }}>S.No.</Text>
                    </View>
                    <View style={{ borderRight: "1px solid black", width: "70%" }}>
                        <Text style={{ textAlign: "center", fontSize: 10, fontFamily: "Poppins", fontWeight: "bold" }}>Traning Programme</Text>
                    </View>
                    <View style={{ width: "20%" }}>
                        <Text style={{ textAlign: "center", fontSize: 10, fontFamily: "Poppins", fontWeight: "bold" }}>Admission</Text>
                    </View>
                </View>
                {newdata.map((item, index) => {
                    return (
                        <View style={[styles.col, { borderBottom: "1px solid black", borderRight: "1px solid black", borderLeft: "1px solid black", fontSize: "10px", textAlign: "center", width: "100%" }]}>
                            <View style={{ borderRight: "1px solid black", width: "10%" }}>
                                <Text style={{ textAlign: "center", fontSize: 10, fontFamily: "Poppins" }}>{index + 1}</Text>
                            </View>
                            <View style={{ borderRight: "1px solid black", width: "70%" }}>
                                <Text style={{ textAlign: "center", fontSize: 10, fontFamily: "Poppins" }}>{item.Course_Name}</Text>
                            </View>
                            <View style={{ width: "20%" }}>
                                <Text style={{ textAlign: "center", fontSize: 10, fontFamily: "Poppins" }}>{item.Student_Count}</Text>
                            </View>
                        </View>
                    )
                })}


                <View style={[styles.col, { borderBottom: "1px solid black", borderRight: "1px solid black", borderLeft: "1px solid black", fontSize: "10px", textAlign: "center", width: "100%" }]}>
                    <View style={{ borderRight: "1px solid black", width: "80%" }}>
                        <Text style={{ textAlign: "right", fontSize: 10, fontFamily: "Poppins", fontWeight: "bold" }}>Total Admission:</Text>
                    </View>
                    <View style={{ width: "20%" }}>
                        <Text style={{ textAlign: "center", fontSize: 10, fontFamily: "Poppins" }}>{totalcount} </Text>
                    </View>

                </View>


            </Page>
        </Document>
    )
}

export default YearlyReport